import { Request, RequestHeaders } from '~src/httpClient/serverApi/requests/Request';

import CustomDomainHttpClient from '../CustomDomainHttpClient';
import { CustomDomainSettingResponse, GetCustomDomainSettingRequest } from '../types/CustomDomainTypes';

// TODO: Remove this as it's used only for local authentication and testing purposes.
  export const headers: RequestHeaders = {
    'x-Tableau-Auth' : '',
    'x-Forwarded-For' : ''
  };

  export class GetCustomDomainRequest extends Request<GetCustomDomainSettingRequest,  CustomDomainSettingResponse> {
    constructor(params: GetCustomDomainSettingRequest) {
      super('GET', params, headers);
    }
  }

  export function fetchCustomDomainSetting(siteLuid: string): Promise<CustomDomainSettingResponse> {
    return CustomDomainHttpClient.requestGet(new GetCustomDomainRequest({site_luid: siteLuid}));
  }